import { gql } from '@apollo/client'

export const IDEAL_DISPLAY_INVENTORY_FACING_FRAGMENT = gql`
  fragment IdealDisplayInventoryFacing on IdealDisplayInventoryFacing {
    upc
    colNum
    vFacings
  }
`
